import React, { useState} from 'react'; 
import $ from 'jquery';
import Swal from 'sweetalert2';
import Coding_course from '../Component/Coding_course.js'
import Allinone from '../Image/Allinone.webp'
import { PiArrowCircleRightThin } from 'react-icons/pi'
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import { FiArrowRightCircle } from 'react-icons/fi'
import Counsellor from './Counsellor.js'
import Coding_course_mobile from './Coding_cource_mobile.js'
import { HiOutlineBuildingLibrary } from "react-icons/hi2";

function Coding_camp() {
  return (
    <div className="">
      <Poster />
      <div className="container-fluid Popular_cource_text text-center mt-5">
        <h1>Coding Skill Program Course</h1>
        <p className="pt-2">
          "Join our renowned Programs; the knowledge provided will surely be
          invaluable to you!"
        </p>
      </div>
      <div className="container d-none d-md-block my-4">
        <div className="container">
          <Coding_course />
        </div>
      </div>
      <div className="d-sm-block d-md-none my-4">
          <Coding_course_mobile/>
      </div>
      <All_in_one />
      <div className='mt-5'>
      <Counsellor/>
      </div>
    </div>
  )
}

const Poster = () => {
  return (
    <div>
    {/* -----------------------Mobile View------------------------ */}
    <div className='Coding_background_image d-sm-block d-md-none mt-5'>
        <div className='container-fluid Coding_background_color pt-5'>
            <div className='text-center Coding_Main_text py-5'>
                <h1 className='display-2 text-white pt-4'>Coding Skill Program</h1>
            </div>
        </div>
    </div>

    {/* -------------------Desktop View------------------------- */}
    <div className='Coding_background_image d-none d-md-block mt-5'>
        <div className='container-fluid Coding_background_color py-5'>
            <div className='text-center py-5 Coding_Main_text my-5'>
                <h1 className='display-3 pt-5 text-white'>Coding Skill Program</h1>
            </div>
        </div>
    </div>
    </div>
  )
}

function All_in_one() {
  const benefits = [
    'Industrial Experts/Mentors',
    'Tailored Curriculum',
    'Continuous Innovation',
    'Interactive Learning Tools',
    'Dedicated Support team',
    'Lifetime Access',
    'Industrial Projects',
    'Hands on Experience',
  ]
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    collegeName: '',
  });

  const [nameError, setNameError] = useState(" ");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [collegeError, setCollegeError] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === 'fullName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setNameError(`Invalid name format.`);
      }
      else {
        setNameError("");
      }
    }

    if (name === 'email') {
      if (!value || !/\S+@\S+\.\S+/.test(value)) {
        setEmailError("Invalid email format");
      } else {
        setEmailError("");
      }

    }

    if (name === 'mobileNo') {
      if (!value || !/^\d{10}$/.test(value)) {
        setPhoneError("Length Should be 10 Digit");
      } else {
        setPhoneError("");
      }
    }
    if (name === 'collegeName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setCollegeError(`Invalid College Name format.`);
      }
      else {
        setCollegeError("");
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    $.ajax({
      url: 'https://forms.internselite.net/traineeship/T7',
      type: 'POST',
      data: {
        fullName: $('[name="fullName"]').val(),
        mobileNo: $('[name="mobileNo"]').val(),
        email: $('[name="email"]').val(),
        collegeName: $('[name="collegeName"]').val()
      },
      success: function (response) {
        Swal.fire({
          title: "Form Submitted!",
          text: "Thank you for applying to our course! Your response has been received, and we appreciate your commitment to learning",
          icon: "success"
        });
        $('[name="fullName"]').val('');
        $('[name="mobileNo"]').val('');
        $('[name="email"]').val('');
        $('[name="collegeName"]').val('');
      },
      error: function (error) {
        console.error('Error:', error);
      }
    });
  };
  return (
    <div>
      <div className="container my-5">
        <div className="container-fluid Popular_cource_text text-center">
          <h1>All in One Course</h1>
          <p className="pt-2">
            "Join our renowned Programs; the knowledge provided will surely be
            invaluable to you!"
          </p>
        </div>
        <div className="All_In_One text-center py-4">
          <img src={Allinone}></img>
        </div>

        {/* --------------------------Desktop View----------------------------- */}
        <div className="d-none d-md-block mt-4">
          <div className="container combo_box_text">
            <div className="row">
              <div className="col-md-8  border rounded px-5 pt-5">
                <div>
                  <div className="border-bottom pb-3">
                    <h1 className="fs-6 fw-bold">
                      Couldn't find your preferred Program?
                    </h1>
                    <h2 className="fs-1">6 Months Coding Skill Program</h2>
                  </div>
                  <div className="row mt-4">
                    {benefits.map((benefit, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="row">
                          <div className="col-1">
                            <PiArrowCircleRightThin
                              size="20px"
                              color="#2b1c50"
                            />
                          </div>
                          <div className="col-11">
                            <p>{benefit}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="border rounded w-100 py-3 my-4 px-5">
                  <div className="combo_card_price">
                    <h6>Original Price: 3,000 + 3,000 + 3,000 + 3,000 + 3,000 = ₹ 15,000</h6>
                    <h5>
                      <FiArrowRightCircle size="20px" color="#00FF00" />
                      Live Session 8-10 Hours
                    </h5>
                    <h5>
                      <FiArrowRightCircle size="20px" color="#00FF00" />{' '}
                      Live+Recorded Sessions for 1 Year Access
                    </h5>
                    <h5>
                      <FiArrowRightCircle size="20px" color="#00FF00" />
                      All Program Completion Certificate
                    </h5>
                    <h2 className='fs-3'>
                      All in One Program Price: <s>₹ 15,000</s> (₹ 10,000)
                    </h2>
                    <button className="px-4 py-2 bg-dark border rounded text-white">
                      Enroll Now
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="">
                  <div className="Program_details_form px-4">
                    <div className="py-4">
                      <form onSubmit={handleSubmit}>
                        <div className="mt-2">
                          <label for="fullName" class="pb-2 contact_form">
                            <SlUser size="18px" /> Full Name
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            id="fullName"
                            name="fullName"
                            placeholder="Full Name"
                            value={formData.fullName}
                            onChange={handleInputChange}
                            required
                          />
                          {nameError && <div className="error text-danger">{nameError}</div>}
                        </div>
                        <div className="mt-3">
                          <label for="email" class="pb-2 contact_form">
                            <MdOutlineMailOutline size="18px" /> Email Address
                          </label>
                          <input
                            className="form-control"
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Email Address"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                          />
                          {emailError && <div className="error text-danger">{emailError}</div>}
                        </div>
                        <div className="mt-3">
                          <label for="mobileNo" class="pb-2 contact_form">
                            <HiOutlinePhone size="18px" /> Phone Number
                          </label>
                          <input
                            className="form-control"
                            type="tel"
                            id="mobileNo"
                            name="mobileNo"
                            placeholder="+91 xxxxxxxxxx"
                            value={formData.mobileNo}
                            onChange={handleInputChange}
                            required
                          />
                          {phoneError && <div className="error text-danger">{phoneError}</div>}
                        </div>
                        <div class="mt-3">
                            <label for="collegeName" class="pb-2 contact_form"><HiOutlineBuildingLibrary size="18px"/>{' '}College Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="collegeName"
                              name="collegeName"
                              placeholder="Your answer"
                              value={formData.collegeName}
                              onChange={handleInputChange}
                              required
                            />
                            {collegeError && <div className="error text-danger">{collegeError}</div>}
                          </div>

                        <div className="row mt-2 pt-4">
                          <div className="d-flex justify-content-center">
                            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --------------------------Mobile View----------------------------- */}
        <div className="d-sm-block d-md-none mt-5">
          <div className="container border rounded py-3 combo_box_text">
            <div className="row">
              <div className="col-md-8">
                <div>
                  <div className="border-bottom pb-3">
                    <h1 className="fw-bold">
                      Couldn't find your preferred courses?
                    </h1>
                    <h2 className="fs-1">6 Months Coding Skill Program</h2>
                  </div>
                  <div className="row my-4">
                    {benefits.map((benefit, index) => (
                      <div className="col-md-6" key={index}>
                        <div className="row">
                          <div className="col-1">
                            <PiArrowCircleRightThin
                              size="20px"
                              color="#2b1c50"
                            />
                          </div>
                          <div className="col-11">
                            <p>{benefit}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="border rounded w-100 py-3 mb-4 px-2">
                  <div className="combo_card_price">
                    <h6>Original Price: 3,000 + 3,000 + 3,000 + 3,000 + 3,000 = ₹ 15,000</h6>
                    <h5>
                      <FiArrowRightCircle size="20px" color="#00FF00" />
                      Live Session 8-10 Hours
                    </h5>
                    <h5>
                      <FiArrowRightCircle size="20px" color="#00FF00" />{' '}
                      Live+Recorded Sessions for 1 Year Access
                    </h5>
                    <h5>
                      <FiArrowRightCircle size="20px" color="#00FF00" />
                      All Program Completion Certificate
                    </h5>
                    <h2>
                      All in One Program Price: <s>₹ 15,000</s> (₹ 10,000)
                    </h2>
                    <button className="px-4 py-2 bg-dark border rounded text-white">
                      Enroll Now
                    </button>
                  </div>
                </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="">
                  <div className="Program_details_form px-4">
                    <div className="py-4">
                      <form onSubmit={handleSubmit}>
                        <div className="mt-2">
                          <label for="fullName" class="pb-2 contact_form">
                            <SlUser size="18px" /> Full Name
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            id="fullName"
                            name="fullName"
                            placeholder="Full Name"
                            value={formData.fullName}
                            onChange={handleInputChange}
                            required
                          />
                          {nameError && <div className="error text-danger">{nameError}</div>}
                        </div>
                        <div className="mt-3">
                          <label for="email" class="pb-2 contact_form">
                            <MdOutlineMailOutline size="18px" /> Email Address
                          </label>
                          <input
                            className="form-control"
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Email Address"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                          />
                          {emailError && <div className="error text-danger">{emailError}</div>}
                        </div>
                        <div className="mt-3">
                          <label for="mobileNo" class="pb-2 contact_form">
                            <HiOutlinePhone size="18px" /> Phone Number
                          </label>
                          <input
                            className="form-control"
                            type="tel"
                            id="mobileNo"
                            name="mobileNo"
                            placeholder="+91 xxxxxxxxxx"
                            value={formData.mobileNo}
                            onChange={handleInputChange}
                            required
                          />
                          {phoneError && <div className="error text-danger">{phoneError}</div>}
                        </div>
                        <div class="mt-3">
                            <label for="collegeName" class="pb-2 contact_form"><HiOutlineBuildingLibrary size="18px"/>{' '}College Name</label>
                            <input
                              className='form-control'
                              type="text"
                              id="collegeName"
                              name="collegeName"
                              placeholder="Your answer"
                              value={formData.collegeName}
                              onChange={handleInputChange}
                              required
                            />
                            {collegeError && <div className="error text-danger">{collegeError}</div>}
                          </div>

                        <div className="row mt-2 pt-4">
                          <div className="d-flex justify-content-center">
                            <button className="text-white shadow-sm fs-5 px-5 pt-1 pb-2 Pr_details_button">
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Coding_camp
